var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.004,
    height: 38.443,
    viewBox: "0 0 40.004 38.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7724",
    "data-name": "Group 7724",
    transform: "translate(1869.264 767.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7355",
    "data-name": "Group 7355",
    transform: "translate(-1869.264 -767.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M-1864.287-738.634a1.13,1.13,0,0,0,.361-.242,1.132,1.132,0,0,0,.248-.374l1.384-3.4a1.132,1.132,0,0,0-.622-1.475h0a1.132,1.132,0,0,0-1.475.622h0l-.339.832a16.234,16.234,0,0,1,3.647-17.356,16.22,16.22,0,0,1,19.7-2.506,1.132,1.132,0,0,0,1.374-.174,1.136,1.136,0,0,0,.175-.226,1.132,1.132,0,0,0-.4-1.55h0a18.485,18.485,0,0,0-22.453,2.856,18.5,18.5,0,0,0-4.109,19.891l-.91-.37a1.131,1.131,0,0,0-1.474.62v0a1.132,1.132,0,0,0,.622,1.475h0l3.4,1.384A1.13,1.13,0,0,0-1864.287-738.634Z",
    transform: "translate(1869.263 767.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M-1673.256-610.935l-3.4-1.384a1.135,1.135,0,0,0-.866.006,1.132,1.132,0,0,0-.608.617l-1.384,3.4a1.132,1.132,0,0,0,.622,1.475h0a1.131,1.131,0,0,0,1.474-.622h0l.387-.953a16.233,16.233,0,0,1-3.533,17.637,16.22,16.22,0,0,1-19.7,2.506,1.132,1.132,0,0,0-1.55.4,1.132,1.132,0,0,0,.4,1.55h0a18.485,18.485,0,0,0,22.453-2.856,18.5,18.5,0,0,0,4.063-20.006l.791.323a1.132,1.132,0,0,0,1.227-.248,1.128,1.128,0,0,0,.247-.374A1.132,1.132,0,0,0-1673.256-610.935Z",
    transform: "translate(1712.559 622.184)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4885",
    "data-name": "Path 4885",
    d: "M-1638.614-579.526h-10.873a.989.989,0,0,0-.989.989v12.85a.989.989,0,0,0,.989.989h10.873a.989.989,0,0,0,.989-.989v-12.85A.989.989,0,0,0-1638.614-579.526Zm-1.493,10.862a.485.485,0,0,1-.485.485h-7.316a.485.485,0,0,1-.485-.485v-.017a.485.485,0,0,1,.485-.485h7.316a.485.485,0,0,1,.485.485Zm0-3.416a.485.485,0,0,1-.485.485h-7.316a.485.485,0,0,1-.485-.485v-.017a.485.485,0,0,1,.485-.485h7.316a.485.485,0,0,1,.485.485Zm0-3.489a.485.485,0,0,1-.485.485h-7.316a.485.485,0,0,1-.485-.485v-.017a.485.485,0,0,1,.485-.485h7.316a.485.485,0,0,1,.485.485Z",
    transform: "translate(-204.947 -175.656)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.8996b15a.svg";
export { ForwardRef as ReactComponent };